import { apiEndpoint } from "../../../services/endpoint";
import { UsersService } from "./supportUser.service";
export const userService = new UsersService(apiEndpoint);
